import _ from './Utils.js'

class AppController {
    constructor(storage) {
        this.storage = storage;
    }
    getTotalCounts() {
        let expenses = this.storage.getStore().expenses.value;
        let transactions = this.storage.getStore().transactions.value;

        return this._computeTotalCounts(expenses, transactions);
    }

    getSubTotal(transactionIndex) {
        let expenses = this.storage.getStore().expenses.value;
        let transactions = this.storage.getStore().transactions.value;
        transactions = transactions.slice(0, transactionIndex + 1)

        return this._computeTotalCounts(expenses, transactions);
    }

    _computeTotalCounts(expenses, transactions) {
        let totalCounts = {};
        totalCounts.total = 0;

        for (let j = 0; j < expenses.length; j++) {
            totalCounts[expenses[j].name] = 0;
        }
        for (let i = 0; i < transactions.length; i++) {
            let transaction = transactions[i];
            if (transaction.category === 'none') {
                continue;
            }
            totalCounts.total += Number.parseFloat(transaction.amount || 0);

            if (!transaction.splits) {
                continue;
            }

            for (var k = 0; k < expenses.length; k++) {
                var exp = expenses[k];
                totalCounts[exp.name] += (transaction.splits[exp.name] || 0);
            }
        }

        return totalCounts;
    }

    updateTransaction(transaction, changed) {
        if(changed.splits) {
            changed.splits = Object.assign({}, transaction.splits, changed.splits);
        }
        transaction = Object.assign({}, transaction, changed);
        //$.extend(transaction, changed); // keep it simple for now, improve it later

        if (changed.amount || changed.category || changed.splits) {
            if (!changed.splits) {
                this.recalculateSplits(transaction);
            }
            transaction.invalidSum = this.validateSummOfTransaction(transaction);
            if (!transaction.invalidSum) {
                delete transaction.invalidSum;
            }
        }
        return this.storage.save([{
            table: 'transactions',
            action: 'UPDATE',
            value: transaction
        }]);
    }

    processPendingTransactions() {
        let batch = [];
        for (var j =0; j < this.storage.getStore().transactions.value.length; j++) {
            var tx = this.storage.getStore().transactions.value[j];
            if (tx.status === 'pending') {
                tx = Object.assign({}, tx, {status: 'processed'});
                this.recalculateSplits(tx);
                batch.push({
                    table: 'transactions',
                    action: 'UPDATE',
                    value: tx
                })
            }
        }
        return this.storage.save(batch);
    }

    recalculateSplits(transaction) {
        var split= this._findTransactionSplitByCategory(transaction.category);

        //delete transaction.invalid;
        //delete transaction.ignore;

        transaction.amount = Number(transaction.amount);
        if (!split || !split.formulas) {
            if (transaction.category === 'none') {
                delete transaction.splits;
            }
            //transaction.ignore = true;
            return;
        }
        
        var amount = transaction.amount;
        let sign = amount> 0? 1: -1;
        var controlSum =0;

        var defaultExpense;
        transaction.splits = {};
        for (var j =0; j < this.storage.getStore().expenses.value.length; j++) {
            var exp = this.storage.getStore().expenses.value[j];
            var koeff = split.formulas[exp.name];
            if (!koeff) {
                continue
            }
            if (exp.default || !defaultExpense) {
                defaultExpense = exp;
            }

            var expSplit = sign * Math.floor(koeff * Math.abs(amount) * 100)/100
            controlSum += expSplit;
            transaction.splits[exp.name] = expSplit;
        }

        if (controlSum.toFixed(2) !== amount.toFixed(2)) {
            let defVal = transaction.splits[defaultExpense.name];
            if (!defVal) {
                defVal = 0;
            }
            transaction.splits[defaultExpense.name] = sign*Math.round(Math.abs((defVal + amount - controlSum)) * 100)/100
        }


    }

    _findTransactionSplitByCategory(category) {
        var splits = this.storage.getStore().transactionSplits.value;
        for (var j =0; j < splits.length; j++) {
            if (splits[j].name === category) {
                return splits[j];      
            }
        }
        return null;
    }

    validateSummOfTransaction(transaction) {
        if (transaction.category === 'none') {
            return null;
        }
        var amount = transaction.amount, splits = transaction.splits;
        var controlSum = 0;
        for (var property in splits) {
            if (Object.prototype.hasOwnProperty.call(splits, property) && !isNaN(splits[property])) {
                controlSum += (1*splits[property])
            }
        }
        return controlSum.toFixed(2) === amount.toFixed(2) ? null: `Row sum ${controlSum.toFixed(2)} doesn't match total sum`;
    }

    addTransaction(date) {

        return this.storage.save([{
            table: 'transactions',
            action: 'INSERT',
            value: {
                uuid: _.uuidv4(),
                date: date
            }
        }]);
    }

    deleteTransactions(uuids) {
        return this.storage.save(uuids.map(item=>({
            table: 'transactions',
            action: 'DELETE',
            value: {
                uuid: item
            }
        })));
    }
}

export default AppController;